import {Injectable} from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import {Topics} from "@common/interfaces/topics";
import {ID} from '@common/interfaces/id';
import {EntityState, EntityStore} from "@datorama/akita";
import {IID_CONFERMA_APPUNTAMENTO} from "@common/interfaces/interfaceData";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export type ConfermaAppuntamentoState = EntityState<IID_CONFERMA_APPUNTAMENTO, ID>

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({name: Topics.IID_CONFERMA_APPUNTAMENTO, realtimeEntity: 'IID_ConfermaAppuntamento'})
@InterfaceDataStore(InterfaceName.IID_CONFERMA_APPUNTAMENTO)
export class ConfermaAppuntamentoStore extends EntityStore<ConfermaAppuntamentoState> {
  constructor() {
    super([]);
  }
}
